import { z } from 'zod';

export const IsoTimestamp = z.string().datetime();
export const UserId = z.string().min(1);
export const DeviceId = z.string().min(1);
export const RunId = z.string().min(1);

export const PaginationQuery = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().positive().max(100).default(50),
});

export type PaginationQuery = z.infer<typeof PaginationQuery>;

export const Paginated = <T extends z.ZodTypeAny>(item: T) =>
  z.object({
    items: z.array(item),
    nextCursor: z.string().optional(),
  });
